// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__96dDI","input":"styles_input__L1GLb","submitButton":"styles_submitButton___1IKT"};